import { useMemo } from "react";
import { useSelector } from "react-redux";
import type { BuildPivotReportRequest } from "../../../../../../../../../api/types/svTypes.ts";
import {
  selectCacheSessionId,
  selectCurrentReportId,
  selectSessionId,
} from "../../../../../store/selectors/currentReportSelectors";
import { selectLogQueries } from "../../../../../store/selectors/devToolsSelectors";
import {
  selectColumns,
  selectConditions,
  selectPivotSettingsState,
  selectRows,
  selectSorts,
  selectValues,
} from "../../../../../store/selectors/fieldsStateSelectors";

export default function useRequestConfigBuilder() {
  const conditionsAreaValues = useSelector(selectConditions);
  const rowsAreaValues = useSelector(selectRows);
  const columnsAreaValues = useSelector(selectColumns);
  const valuesAreaValues = useSelector(selectValues);
  const sortAreaValues = useSelector(selectSorts);
  const settingsAreaValues = useSelector(selectPivotSettingsState);
  const reportId = useSelector(selectCurrentReportId);

  const isQueryLoggingActive = useSelector(selectLogQueries);
  const sessionId = useSelector(selectSessionId);
  const cacheSessionId = useSelector(selectCacheSessionId);

  const requestConfig = useMemo((): BuildPivotReportRequest => {
    const request: BuildPivotReportRequest = {
      conditions: conditionsAreaValues.map((c) => ({ ...c.config, invalid: c.validation?.invalid })),
      rows: rowsAreaValues.map((v) => v.config),
      columns: columnsAreaValues.map((v) => v.config),
      values: valuesAreaValues.map((v) => v.config),
      sort: sortAreaValues.map((s) => s.config),
      settings: structuredClone(settingsAreaValues),
      reportId: reportId ?? "",
      sessionId,
      cacheSessionId,
      useQueryLogging: isQueryLoggingActive === true,
      withDrilldown: true,
    };

    return request;
  }, [
    conditionsAreaValues,
    rowsAreaValues,
    columnsAreaValues,
    valuesAreaValues,
    sortAreaValues,
    settingsAreaValues,
    reportId,
    sessionId,
    cacheSessionId,
    isQueryLoggingActive,
  ]);

  return { requestConfig };
}
